import { TFunction } from 'i18next'

import { CompanyCountryId } from '../types/companyCountryId'
import { isCompanyCountryId } from './isCompanyCountryId'

const vatNoInvalidFormatErrorTKeyByCountry: Record<CompanyCountryId, string> = {
  DE: 'external_invoices.missing_company_compliance_details.modal.form.field.vat_no.org_DE.error.invalid_format',
  FR: 'external_invoices.missing_company_compliance_details.modal.form.field.vat_no.org_FR.error.invalid_format',
  NL: 'external_invoices.missing_company_compliance_details.modal.form.field.vat_no.org_NL.error.invalid_format',
  DK: 'external_invoices.missing_company_compliance_details.modal.form.field.vat_no.org_DK.error.invalid_format',
}

export const getVatNumberFieldInvalidFormatErrorMessage = (countryId: string | undefined, t: TFunction): string => {
  if (!countryId || !isCompanyCountryId(countryId)) {
    return ''
  }

  return t(vatNoInvalidFormatErrorTKeyByCountry[countryId])
}
